export default function addURLSearch(url: string, options = {}) {
  const urlArr = url.split('?');
  const dealSearchStr = (obj = {}, options = {}, hash = '') => {
    let searchStr = '';
    const tmp: { [key: string]: string | number } = Object.assign({}, obj, options);
    let t = 0;
    Object.keys(tmp).forEach((key) => {
      searchStr += `${(t !== 0 ? '&' : '') + key}=${tmp[key]}`;
      t = t + 1;
    });

    if (hash) {
      // add hash #
      searchStr += `#${hash}`;
    }
    if (t !== 0) {
      // add ?
      searchStr = `?${searchStr}`;
    }
    return searchStr;
  };

  let resStr = '';
  if (urlArr[1]) {
    // extract location.search
    const searchArr = urlArr[1].split('#');
    const lists = searchArr[0].split('&');
    const obj: { [key: string]: string | number } = {};
    lists.forEach((list) => {
      const arr = list.split('=');
      obj[arr[0]] = arr[1] || '';
    });
    resStr = dealSearchStr(obj, options, searchArr[1]);
  } else {
    resStr = dealSearchStr({}, options, urlArr[0].split('#')[1]);
  }
  return urlArr[0] + resStr;
}
